import { Box, CardMedia } from "@mui/material";
import AnimatedCar from "./components/AnimatedCar";
import LineOneIcon from "@/assets/icons/why-trackmate/line_1.svg?react";
import line_two_icon from "@/assets/icons/why-trackmate/line_2.svg";
import line_three_icon from "@/assets/icons/why-trackmate/line_3.svg";
import truck_icon from "@/assets/icons/why-trackmate/truck.svg";
import individual_icon from "@/assets/icons/why-trackmate/individual.svg";
import { useEffect, useMemo, useState } from "react";
import { getLeftOptions, getRightOptions, individualSizes, linesSizes, truckSizes } from "./mockData";
import useResponsive from "@/hooks/useResponsive";
import { getSize } from "../../../Map/utils";

const Cars = () => {
  const isTablet = useResponsive("between", "md", "lg");
  const [reset, setReset] = useState<number>(1);
  const sizes = useMemo(() => isTablet ? linesSizes.md : linesSizes.lg, [isTablet]);
  const leftOptions = useMemo(() => {
    const getWidth = getSize(linesSizes.lg.left.width / sizes.left.width);
    const getHeight = getSize(linesSizes.lg.left.height / sizes.left.height);
    return getLeftOptions(getWidth, getHeight);
  }, [sizes]);
  const rightOptions = useMemo(() => {
    const getWidth = getSize(linesSizes.lg.right.width / sizes.right.width);
    const getHeight = getSize(linesSizes.lg.right.height / sizes.right.height);
    return getRightOptions(getWidth, getHeight);
  }, [sizes]);

  const onChange = () => {
    return !document.hidden && setReset((prev) => prev + 1);
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', onChange);

    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);
  return (
    <Box key={reset}>
      <Box
        sx={{
          position: "absolute",
          top: "70px",
          left: "-98px"
        }}
      >
        <LineOneIcon />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "454px",
          right: "75%"
        }}
      >
        <AnimatedCar options={leftOptions.truck} image={truck_icon} sx={truckSizes}>
        </AnimatedCar>
        <AnimatedCar options={leftOptions.car} image={individual_icon} sx={individualSizes}>
        </AnimatedCar>
        <CardMedia 
          component="img"
          image={line_two_icon}
          sx={sizes.left}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "360px",
          left: "80%"
        }}
      >
        <AnimatedCar options={rightOptions.car} image={individual_icon} sx={individualSizes}>
        </AnimatedCar>
        <AnimatedCar options={rightOptions.truck} image={truck_icon} sx={truckSizes}>
        </AnimatedCar>
        <CardMedia 
          component="img"
          image={line_three_icon}
          sx={sizes.right}
        />
      </Box>
    </Box>
  );
};

export default Cars;